import { Component, OnInit } from '@angular/core';
import { RecurringFrequency } from '../../models/frequency.model';
import * as moment from 'moment';

@Component({
  selector: 'app-frequency-form',
  templateUrl: './frequency-form.component.html',
  styleUrls: ['./frequency-form.component.scss'],
})
export class FrequencyFormComponent implements OnInit {
  recurringFrequency: RecurringFrequency;
  minDate = new Date();

  constructor() {
    this.recurringFrequency = new RecurringFrequency();
    this.minDate.setDate(this.minDate.getDate() + 1);
  }

  ngOnInit(): void {
    this.setFrequencyDefaults();
  }

  changeRecurringEndType(event) {
    this.recurringFrequency.EndType = event.target.value;
  }

  changeRecurringFrequencyType(event) {
    const dayOfTheWeek = moment().format('dd').toUpperCase();
    this.recurringFrequency.FrequencyType = +event.target.value;

    if (event.target.value == 3) {
      this.recurringFrequency.ByDay = dayOfTheWeek;
    } else {
      this.recurringFrequency.ByDay = dayOfTheWeek;
      this.recurringFrequency.ByDayArray = [];
      this.recurringFrequency.ByDayArray.push(dayOfTheWeek);
    }
  }

  changeRecurringByMonth(event) {
    this.recurringFrequency.ByMonth = +event.target.value;
  }

  changeRecurringBySetPos(event) {
    this.recurringFrequency.BySetPos = +event.target.value;
  }

  changeRecurringByDay(day: string, type: string) {
    if (type === 'multiple') {
      const isSelected = this.recurringFrequency.ByDayArray.find(
        (e) => e === day
      );
      if (isSelected) {
        this.recurringFrequency.ByDayArray =
          this.recurringFrequency.ByDayArray.filter((e) => e !== day);
      } else {
        this.recurringFrequency.ByDayArray.push(day);
      }

      this.recurringFrequency.ByDay =
        this.recurringFrequency.ByDayArray.join(',');
    } else {
      this.recurringFrequency.ByDay = day;
    }
  }

  changeRecurringDayType(type: string) {
    this.recurringFrequency.DayType = type;
  }

  setFrequencyDefaults() {
    this.recurringFrequency.ByDay = moment().format('dd').toUpperCase();
    this.recurringFrequency.ByDayArray = [moment().format('dd').toUpperCase()];
    this.recurringFrequency.ByMonth = +moment().format('M');
    this.recurringFrequency.ByMonthDay = +moment().format('D');
  }
}
